var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import LucidLinkSvg from './lucid-link.icon.svg';
export const LucidLinkIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, fillOpacity: 1, SvgComponent: LucidLinkSvg }));
_react_refresh_temp_1 = LucidLinkIcon;
$RefreshReg$(_react_refresh_temp_1, "LucidLinkIcon");
